var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaytikoId1FrDBxXr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 63,
    viewBox: "0 0 238 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1101_12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1101_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5158 43.2289C71.5158 45.5418 68.5651 48.5664 63.1883 48.5664C58.7514 48.5664 54.5549 46.5648 51.9102 43.429C49.5715 40.6713 48.0852 36.9128 48.0852 32.754C48.0852 23.7691 54.6204 16.8748 62.7731 16.8748C68.4559 16.8748 71.4065 19.8771 71.5377 22.2123V17.4975H79.2532V47.9437H71.5377V43.2289H71.5158ZM71.2098 28.1726C69.5487 25.9041 66.8822 24.414 63.8003 24.414C59.1011 24.414 56.0848 28.3727 56.0848 32.754C56.0848 37.5133 59.4727 41.0271 63.9752 41.0271C66.9914 41.0271 69.658 39.5148 71.188 37.2686V28.1726H71.2098Z",
    fill: "url(#paint0_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5916 63L97.8535 44.8746L84.4771 17.5197H93.3072L102.072 35.7785L110.159 17.5197H118.618L98.0065 63.0222H89.6134L89.5916 63Z",
    fill: "url(#paint1_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.19 47.9437C147.141 48.3218 144.736 48.5665 143.185 48.5665C138.376 48.5665 134.857 46.943 132.824 44.1852C131.273 42.1169 130.595 39.4259 130.595 35.0892V24.4141H122.268V17.5197H130.595V9.04639H138.617V17.5197H148.474V24.4141H138.617V36.0232C138.617 37.9136 138.923 39.0256 139.6 39.8485C140.409 40.7825 141.698 41.3608 143.666 41.3608C144.846 41.3608 146.376 41.1829 146.922 41.0494L148.146 47.9437H148.19Z",
    fill: "url(#paint2_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.211 1.50708C163.118 1.50708 165.457 3.77554 165.457 6.71119C165.457 9.64684 163.118 11.9153 160.211 11.9153C157.305 11.9153 154.966 9.64684 154.966 6.71119C154.966 3.77554 157.305 1.50708 160.211 1.50708ZM164.211 47.9437H156.19V17.5197H164.211V47.966V47.9437Z",
    fill: "url(#paint3_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.472 31.1972L204.952 47.966H194.155L181.5 34.7778V47.966H173.478V3.39746H181.5V27.3497L191.794 17.4975H203.073L188.45 31.1749L188.472 31.1972Z",
    fill: "url(#paint4_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.088 16.8748C231.159 16.8748 238 23.9692 238 32.754C238 41.5387 231.159 48.5664 222.088 48.5664C213.017 48.5664 206.176 41.5387 206.176 32.754C206.176 23.9692 213.017 16.8748 222.088 16.8748ZM222.088 41.0271C226.787 41.0271 229.978 37.3131 229.978 32.754C229.978 28.1948 226.765 24.414 222.088 24.414C217.411 24.414 214.198 28.1726 214.198 32.754C214.198 37.3353 217.411 41.0271 222.088 41.0271Z",
    fill: "url(#paint5_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7303 7.91212C40.2823 5.31007 36.5885 3.99792 31.6051 3.99792H15.5403V47.5212H23.7803V29.7961H31.6051C36.2606 29.7961 39.8015 28.6841 42.2057 26.4601C42.2494 26.4379 42.2932 26.3934 42.315 26.3489C42.4462 26.2155 42.5773 26.082 42.7084 25.9486C43.6264 24.9923 44.3477 23.9248 44.8941 22.746C45.681 21.0336 46.0744 19.0987 46.0744 16.9415C46.0744 13.2941 44.9597 10.2918 42.7084 7.91212H42.7303ZM23.7803 11.4705H31.2336C33.6378 11.4705 35.3645 12.0487 36.4355 13.2052C37.3753 14.2505 37.8343 15.4959 37.8343 16.9415C37.8343 18.3871 37.3753 19.5658 36.4355 20.611C35.3864 21.7675 33.6378 22.3457 31.2336 22.3457H23.7803V11.4482V11.4705Z",
    fill: "url(#paint6_linear_1101_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8888 24.503C43.4298 25.7484 42.7741 26.8604 41.9654 27.8612C41.8561 28.0169 41.725 28.1503 41.6157 28.2837C41.5938 28.3282 41.5501 28.3505 41.5283 28.3949C39.277 30.9303 37.1787 31.9755 35.5832 32.4426C33.0041 33.1987 30.4905 32.8429 28.0207 31.8866C24.7203 30.6412 21.4855 28.3505 18.1632 26.4156C13.6825 23.7913 9.07074 21.7675 3.99993 23.6356C2.16395 24.3028 0.786965 25.3036 0.0219727 25.9041C2.86337 21.7675 5.57363 20.2774 7.27847 19.6547C11.0379 18.2536 14.6005 19.2099 18.1632 20.8557C24.5892 23.8358 31.1025 29.0177 39.1021 26.7492C41.1567 26.171 42.8178 25.2369 43.9107 24.4807L43.8888 24.503Z",
    fill: "#52CA96"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_12",
    x1: 13.2671,
    y1: 32.7095,
    x2: 233.301,
    y2: 32.7095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1101_12",
    x1: 0.0000611756,
    y1: 40.2487,
    x2: 233.301,
    y2: 40.2487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1101_12",
    x1: -0.0000508858,
    y1: 28.7953,
    x2: 233.301,
    y2: 28.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1101_12",
    x1: 0.000409434,
    y1: 24.7254,
    x2: 233.301,
    y2: 24.7254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1101_12",
    x1: -0.0000378675,
    y1: 25.6595,
    x2: 233.301,
    y2: 25.6595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1101_12",
    x1: -0.0000154569,
    y1: 32.7317,
    x2: 2.18568,
    y2: 32.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1101_12",
    x1: 0.0000139373,
    y1: 25.7484,
    x2: 233.301,
    y2: 25.7484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A4DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CA96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 63,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1101_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 63,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1101_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 61.493,
    fill: "white",
    transform: "translate(0 1.50708)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaytikoId1FrDBxXr1);
export default __webpack_public_path__ + "static/media/Paytiko_id1FrDBxXR_1.225ce6def8a147d18b8a8c77891389eb.svg";
export { ForwardRef as ReactComponent };